import React from 'react';
import ToDoList from './ToDoList';

/**
 * GlobalToDoModal — the ⌘K / "+ Add" popup. It is now just a shell around the
 * ONE rich ToDoList in master mode, so the popup, the /master-todo page and the
 * dashboard panel are byte-for-byte the same list.
 */
export default function GlobalToDoModal({ isOpen, onClose }) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4" style={{ background: 'rgba(0,0,0,0.9)' }} data-testid="global-todo-modal">
      <div
        className="flex h-[90vh] w-full max-w-5xl flex-col overflow-hidden rounded-2xl"
        style={{ border: '2px solid #8b7355', background: 'linear-gradient(135deg, #1a1a2e 0%, #0f0f1a 100%)' }}
      >
        <div className="flex flex-shrink-0 items-center justify-end px-4 py-2">
          <button
            onClick={onClose}
            data-testid="global-todo-close"
            className="grid h-10 w-10 place-items-center text-3xl text-gray-400 hover:text-white"
          >
            ×
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          <ToDoList masterMode />
        </div>
      </div>
    </div>
  );
}
